import React from 'react';
import { View, ScrollView, Text, Image, TouchableOpacity } from 'react-native';
import { LinearGradient } from "expo-linear-gradient";
import { useNavigation } from '@react-navigation/native';

import styles from './style';

const CardsHome = () => {
    const navigation = useNavigation();

    return (
        <ScrollView
            horizontal={true}
            showsHorizontalScrollIndicator={false}
            style={styles.container}
        >
            <View style={styles.contentCard}>
                <TouchableOpacity
                    onPress={() => navigation.navigate("Purchase", { viewType: "buy" })}
                >
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1.3, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.card}
                    >
                        <Image
                            source={require("../../../assets/home/icons/comprar.png")}
                            style={styles.img}
                        />
                        <Text style={styles.textCard}>Comprar</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>

            <View style={styles.contentCard}>
                <TouchableOpacity
                    onPress={() => navigation.navigate("Purchase", { viewType: "sell" })}
                >
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1.3, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.card}
                    >
                        <Image
                            source={require("../../../assets/home/icons/comprar.png")}
                            style={styles.img}
                        />
                        <Text style={styles.textCard}>Vender</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>

            <View style={styles.contentCard}>
                <TouchableOpacity onPress={() => navigation.navigate("Transfer")}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1.3, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.card}
                    >
                        <Image
                            source={require("../../../assets/home/icons/transferir.png")}
                            style={styles.img}
                        />
                        <Text style={styles.textCard}>Transferir</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>

            <View style={styles.contentCard}>
                <TouchableOpacity onPress={() => navigation.navigate("DepositMethod")}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1.3, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.card}
                    >
                        <Image
                            source={require("../../../assets/home/icons/pagar.png")}
                            style={styles.img}
                        />
                        <Text style={styles.textCard}>Depositar</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>

            <View style={styles.contentCard}>
                <TouchableOpacity onPress={() => navigation.navigate("WithdrawMethod")}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1.3, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.card}
                    >
                        <Image
                            source={require("../../../assets/home/icons/pagar.png")}
                            style={styles.img}
                        />
                        <Text style={styles.textCard}>Sacar</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>

            {/* <View style={styles.contentCard}>
                <TouchableOpacity onPress={() => navigation.navigate("PaymentMethodPay")}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1.3, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.card}
                    >
                        <Image source={require('../../../assets/home/icons/pagar.png')} style={styles.img} />
                        <Text style={styles.textCard}>Pagar</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View> */}
        </ScrollView>
    );
}

export default CardsHome;
